export default {"src":"/_next/static/media/serranopepper.6ced92e2.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};